import { type MotifComponent, type MotifComponentProps, m } from '../../motif';

export const snapCookieComponentsPrimaryVars: MotifComponentProps<MotifComponent.COOKIE_MODAL_SETTINGS> =
  {
    '--cookie-modal-body-inline-padding': '0px',
    '--cookie-modal-border-color': m('--fg-color'),
    '--cookie-modal-border-radius': '0px',
    '--cookie-modal-border-width': m('--border-width-xs'),
    '--cookie-modal-box-shadow': m('--box-shadow-l'),
    '--cookie-modal-logo-opacity': '0',
    '--cookie-modal-min-width': '580px',
    '--cookie-modal-desktop-vertical-padding': m('--spacing-l'),
    '--cookie-modal-desktop-horizontal-padding': m('--spacing-l'),
    '--cookie-modal-mobile-vertical-padding': m('--spacing-s'),
    '--cookie-modal-mobile-horizontal-padding': m('--spacing-s'),
    '--cookie-modal-rich-text-title-desktop-font-size': m('--h6-desktop-font-size'),
    '--cookie-modal-rich-text-title-desktop-font-line-height': m('--h6-desktop-font-line-height'),
    '--cookie-modal-rich-text-title-desktop-font-weight': m('--h6-desktop-font-weight'),
    '--cookie-modal-rich-text-title-desktop-font-stretch': m('--h6-desktop-font-stretch'),
    '--cookie-modal-rich-text-title-mobile-font-size': m('--h6-mobile-font-size'),
    '--cookie-modal-rich-text-title-mobile-font-line-height': m('--h6-mobile-font-line-height'),
    '--cookie-modal-rich-text-title-mobile-font-weight': m('--h6-mobile-font-weight'),
    '--cookie-modal-rich-text-title-mobile-font-stretch': m('--h6-mobile-font-stretch'),
    '--cookie-modal-rich-text-base-desktop-font-size': m('--p3-desktop-font-size'),
    '--cookie-modal-rich-text-base-desktop-font-line-height': m('--p3-desktop-font-line-height'),
    '--cookie-modal-rich-text-base-desktop-font-weight': m('--p3-desktop-font-weight'),
    '--cookie-modal-rich-text-base-desktop-font-stretch': m('--p3-desktop-font-stretch'),
    '--cookie-modal-rich-text-base-mobile-font-size': m('--p3-mobile-font-size'),
    '--cookie-modal-rich-text-base-mobile-font-line-height': m('--p3-mobile-font-line-height'),
    '--cookie-modal-rich-text-base-mobile-font-weight': m('--p3-mobile-font-weight'),
    '--cookie-modal-rich-text-base-mobile-font-stretch': m('--p3-mobile-font-stretch'),
    '--cookie-settings-box-shadow': 'none',
    '--cookie-settings-max-width': '800px',
    '--cookie-settings-border-width': m('--border-width-none'),
    '--cookie-settings-padding': m('--spacing-l'),
    '--cookie-settings-category-border-color': m('--neutral-v250'),
    '--cookie-settings-category-border-radius': '0px',
    '--cookie-settings-category-border-width': m('--border-width-xs'),
    '--cookie-settings-category-padding': m('--spacing-s'),
    '--cookie-settings-category-title-desktop-font-size': m('--h6-desktop-font-size'),
    '--cookie-settings-category-title-desktop-font-line-height': m('--h6-desktop-font-line-height'),
    '--cookie-settings-category-title-desktop-font-weight': m('--h6-desktop-font-weight'),
    '--cookie-settings-category-title-desktop-font-stretch': m('--h6-desktop-font-stretch'),
    '--cookie-settings-category-title-mobile-font-size': m('--h6-mobile-font-size'),
    '--cookie-settings-category-title-mobile-font-line-height': m('--h6-mobile-font-line-height'),
    '--cookie-settings-category-title-mobile-font-weight': m('--h6-mobile-font-weight'),
    '--cookie-settings-category-title-mobile-font-stretch': m('--h6-mobile-font-stretch'),
    '--cookie-settings-category-description-desktop-font-size': m('--p2-desktop-font-size'),
    '--cookie-settings-category-description-desktop-font-line-height': m(
      '--p2-desktop-font-line-height'
    ),
    '--cookie-settings-category-description-desktop-font-stretch': m('--p2-desktop-font-stretch'),
    '--cookie-settings-category-description-desktop-font-weight': m('--p2-desktop-font-weight'),
    '--cookie-settings-category-description-mobile-font-size': m('--p2-mobile-font-size'),
    '--cookie-settings-category-description-mobile-font-line-height': m(
      '--p2-mobile-font-line-height'
    ),
    '--cookie-settings-category-description-mobile-font-stretch': m('--p2-mobile-font-stretch'),
    '--cookie-settings-category-description-mobile-font-weight': m('--p2-mobile-font-weight'),
  } as const;
